const category = 'Notification';

export default Object.freeze({
  VISIT: Object.freeze({
    category,
    action: 'List',
    label: 'Click'
  })
});
